import React, { useMemo, useState } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { DocumentIcon, EyeIcon } from '@heroicons/react/solid';
import Modal from '../../components/modal';
import useFeedback from '../../hooks/useFeedback';
import Rating from '../../components/Rating';

const UserList = () => {
  const feedbackQuery = useFeedback();
  const [selectedFeedback, setSelectedFeedback] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  const rows = feedbackQuery.data || [];

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'firstName',
        headerName: 'Voornaam',
        flex: 1,
        valueGetter: (params: any) =>
          params?.row?.user?.firstName || 'Gebruiker niet gevonden',
      },
      {
        field: 'lastName',
        headerName: 'Achternaam',
        flex: 1,
        valueGetter: (params: any) => params?.row?.user?.lastName,
      },
      {
        field: 'createdAt',
        headerName: 'Aangemaakt',
        flex: 1,
        valueGetter: (params: any) => {
          return params?.row?.createdAt?.slice(0, 10);
        },
      },
      {
        field: 'rating',
        headerName: 'Rating',
        flex: 2,
        renderCell: (params) => {
          return (
            <div className="w-full">
              <Rating
                rating={params?.row?.rating || 0}
                onChange={() => {}}
                disabled
              />
            </div>
          );
        },
      },
      {
        field: 'courseId',
        headerName: 'module',
        flex: 2,
        valueGetter: (params: any) => {
          return params?.row?.course?.title || 'Module niet gevonden';
        },
      },
      {
        field: 'feedback',
        headerName: 'Feedback',
        flex: 1,
        renderCell: (params) => {
          if (params?.row?.feedback.length > 0) {
            return (
              <button
                onClick={() => {
                  setSelectedFeedback(params?.row?.feedback);
                  setModalOpen(true);
                }}
                title="Feedback"
                className=" bg-sky rounded-md p-2 flex space-x-1"
              >
                <DocumentIcon className="w-5 text-white" />
                <EyeIcon className="w-5 text-white" />
              </button>
            );
          }
          return null;
        },
      },
    ];
  }, []);

  return (
    <>
      <Modal
        isOpen={modalOpen}
        setOpen={setModalOpen}
        onConfirm={async () => {
          setSelectedFeedback('');
          setModalOpen(false);
          return true;
        }}
        showCancel={false}
        title="Feedback"
        confirmText="Sluiten"
      >
        <p>{selectedFeedback}</p>
      </Modal>
      <DataGrid
        autoHeight
        rows={rows}
        columns={columns}
        getRowId={(row) => row._id}
      />
    </>
  );
};

export default UserList;
